import React, {Component} from 'react';
import { withRouter, Link } from 'react-router-dom';
import Container from './application_container';

class Error404 extends Component {
    render() {
        return (
            <Container title="Error" title1="Access Denied">
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '60px 20px',
                    textAlign: 'center'
                }}>
                    <div style={{
                        width: '80px',
                        height: '80px',
                        borderRadius: '20px',
                        background: '#FEF2F2',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBottom: '24px'
                    }}>
                        <i className="icon-lock2" style={{fontSize: '32px', color: '#EF4444'}}></i>
                    </div>
                    <h1 style={{
                        fontSize: '48px',
                        fontWeight: '800',
                        color: '#0F172A',
                        margin: '0 0 8px',
                        letterSpacing: '-0.04em'
                    }}>403</h1>
                    <h5 style={{
                        fontSize: '16px',
                        fontWeight: '600',
                        color: '#475569',
                        margin: '0 0 8px'
                    }}>Access Denied</h5>
                    <p style={{
                        fontSize: '14px',
                        color: '#94A3B8',
                        margin: '0 0 32px',
                        maxWidth: '360px'
                    }}>
                        You don't have permission to access this page. Please contact your administrator.
                    </p>
                    <Link
                        to={"/"}
                        style={{
                            background: 'linear-gradient(135deg, #10B981, #059669)',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '10px',
                            padding: '10px 24px',
                            fontSize: '13px',
                            fontWeight: '600',
                            textDecoration: 'none',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                            boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)',
                            transition: 'all 200ms ease'
                        }}
                    >
                        <i className="icon-home4" style={{fontSize: '14px'}}></i>
                        Back to Dashboard
                    </Link>
                </div>
            </Container>
        );
    }
}

export default withRouter(Error404);
